import { useState, useEffect } from "react";
import { useSelector ,useDispatch } from "react-redux";
import WwRow from "./WwRow";
import { CheckActions, resetAudio, initAudioReset } from "../../../../Js/ILTActions";
import { currentILTActionsSliceActions } from "../../../../Store/Slices/CurrentILTActions";
import "./style.css";

const WwMain = (props) => {
  const dispatch = useDispatch();
  let [initHide, setInitHide] = useState([]);

  const { svgLoad } = useSelector((state) => state.currentILTActions);

  useEffect(() => {
    console.log("!@#$%", props.data);
  }, [props.data]);

  useEffect(() => {
      console.log("!@#$%11111111111111111111111111", props.actions.init.action);
    dispatch(currentILTActionsSliceActions.resetState());
    dispatch(currentILTActionsSliceActions.setActionsData(props.actions));

    if (props.actions && props.actions.init && props.actions.init.action) {
      console.log("!@#$%", props.actions.init.action);
      props.actions.init.action.forEach((val, index) => {
        val.items.forEach((innerVal, index1) => {
          if (innerVal.action == "hideContent") {
            let arr = [...initHide];
            arr = arr.concat(innerVal.referances);
            setInitHide(arr);
          }
          else{
            if(innerVal.action == 'audPlay'){
              dispatch(currentILTActionsSliceActions.setInitAudio(innerVal.source[0]))
            }
            CheckActions(innerVal,'init');
          }
          
        });
      });
    }

    return () => {
      setInitHide([]);
      resetAudio();
      initAudioReset();
    };
  }, [props.actions]);

  useEffect(() => {
    console.log("svgLoad",svgLoad);
    if (props.actions && props.actions.init && props.actions.init.action && svgLoad) {
      console.log("!@#$%", props.actions.init.action);
      props.actions.init.action.forEach((val, index) => {
        val.items.forEach((innerVal, index1) => {
          CheckActions(innerVal,'init');
          if(innerVal.action == 'audPlay'){
            dispatch(currentILTActionsSliceActions.setInitAudio(innerVal.source[0]))
          }
        });
      });
    }
    if (props.actions && props.actions.buttons && svgLoad) {
      props.actions.buttons.forEach((val, index) => {
        if (val.buttonId !== "controlbtn") {
          let docId = document.getElementById(val.buttonId);
          if (docId) {
            docId.addEventListener("click", () => {
              val.click[0].items.forEach((innerVal, index1) => {
                CheckActions(innerVal, svgLoad ? 'svg':'notSvg');
              });
            });
          }
        }
      });
    }
  },[svgLoad])

  return (
    <>
      {props.data && <WwRow data={props.data[0]} initHide={initHide}></WwRow>}
    </>
  );
};

export default WwMain;
